module.exports = __webpack_public_path__ + "img/zotic_exzoticfarms.f0e8934.png";